<template>
  <v-dialog v-model="dialogOpen" persistent width="450">
    <v-card :disabled="formLoading">
      <v-card-title>
        Product Status Reason
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="12">
            <v-autocomplete v-model="status_reason" label="Product Status Reason" placeholder="Select an option" outlined dense :items="getStaticData" item-text="value" item-value="value" :loading="getStaticDataLoading" :disabled="getStaticDataLoading" hide-details="auto" :error-messages="statusReasonErrors" @input="$v.status_reason.$touch()" @blur="$v.status_reason.$touch()"></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="12">
            <v-textarea hide-details dense label="Product Status Reason Notes" v-model="status_reason_notes" outlined placeholder="Type here...">
            </v-textarea>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed outlined :loading="formLoading" @click="save">Save</v-btn>
        <v-btn depressed outlined :disabled="formLoading" @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { validationMixin } from "vuelidate";
  import { required } from "vuelidate/lib/validators";
  import { mapState,mapGetters,mapActions } from "vuex";
  
  export default {
    props: {
      dialogOpen: {
        type: Boolean,
        default: false
      },
      statusChange: {
        type: String, 
        default: ""
      }
    },

    mixins: [ validationMixin ],

    validations: {
      status_reason: { required }
    },

    data() {
      return {
        formLoading: false,
        status_reason: "",
        status_reason_notes: "",
        statuses: {
          doa: 'doa_reason',
        }
      }
    },

    computed: {
      ...mapState("products", ["currentProduct"]),
      ...mapGetters("staticData", ["getStaticData", "getStaticDataLoading"]),

      statusReasonErrors() {
        const errors = [];
        if (!this.$v.status_reason.$dirty) return errors;
        !this.$v.status_reason.required && errors.push("Product Status Reason is a required field");
        return errors;
      }
    },

    watch: {
      dialogOpen(val) {
        if(val){
          this.fetchStaticData({ kind: this.currentProduct.product_kind.toUpperCase(), field: this.statuses[this.statusChange.toLowerCase()] });
        }
      }
    },

    methods: {
      ...mapActions('staticData', ['fetchStaticData']),
      ...mapActions('products', ['updateProductStatuses', 'updateProductData']),

      reset() {
        this.$v.$reset();
        this.status_reason = '';
        this.status_reason_notes = '';
      },

      close() {
        this.reset();
        this.$emit('close-dialog');
      },

      async save() {
        this.$v.$touch();
        
        if(!this.$v.$invalid){
          this.formLoading = true;
          try{
            let data = {
              productId: this.currentProduct.id,
              status: {status: this.statusChange},
            }

            let success = await this.updateProductStatuses(data);
            if(success){
              await this.updateProductData({ id: this.currentProduct.id, data: {status_reason: this.status_reason , status_reason_notes: this.status_reason_notes }});
              window.location.reload();
            }
            this.formLoading = false;
            this.close();
          }catch(error){
            this.formLoading = false;
          }
        }
      },
    },
  }
</script>

<style lang="scss" scoped></style>